import { useState } from 'react';
import { useAuth } from '../lib/auth.jsx';
import { useData } from '../lib/data.jsx';
import { useUI, Sec, Row } from '../lib/ui.jsx';
import { B, thDateTime } from '../lib/util.js';

export default function Customers({ go }) {
  const { tiers } = useAuth();
  const { customers, contracts } = useData();
  const { openDrawer, closeDrawer } = useUI();
  const [q, setQ] = useState('');

  const custName = (c) => c.entity === 'company' ? c.company : `${c.first_name || ''} ${c.last_name || ''}`.trim();
  const historyOf = (id) => contracts.filter(ct => ct.customer_id === id);
  const totalOf = (id) => historyOf(id).reduce((s, ct) => s + Number(ct.net_rent), 0);
  const tierOf = (key) => tiers.find(t => t.key === key) || { name: key, dep_pct: 0, rent_mul: 1 };

  const list = customers.filter(c => {
    const s = q.toLowerCase().trim();
    if (!s) return true;
    return [custName(c), c.phone, c.email, c.line_id, c.tax_id].join(' ').toLowerCase().includes(s);
  });

  const openCust = (c) => {
    const hist = historyOf(c.id);
    const t = tierOf(c.tier);
    const d = null; // deliverable per-contract — ดูในสัญญา
    openDrawer(c.entity === 'company' ? 'ลูกค้านิติบุคคล · COMPANY' : 'ลูกค้าบุคคลธรรมดา · CUSTOMER', custName(c), (<>
      <Sec>ข้อมูลติดต่อ</Sec>
      {c.entity === 'company' && (<>
        <Row k="เลขประจำตัวผู้เสียภาษี" v={c.tax_id || '—'} />
        <Row k="สำนักงาน" v={c.tax_branch || '—'} />
        <Row k="ผู้ติดต่อ" v={c.contact || '—'} />
      </>)}
      <Row k="โทรศัพท์" v={c.phone || '—'} />
      <Row k="อีเมล" v={c.email || '—'} />
      <Row k="LINE" v={c.line_id || '—'} />
      {c.address && <><div className="dw-row"><span>ที่อยู่</span></div>
        <div style={{ fontSize: 13, color: '#555', paddingBottom: 6 }}>{c.address}</div></>}
      <Sec>ระดับและเงื่อนไข</Sec>
      <Row k="ระดับ" v={t.name} />
      <Row k="มัดจำ" v={Math.round(Number(t.dep_pct) * 100) + '%'} />
      <Row k="เรทค่าเช่า" v={Number(t.rent_mul) === 0 ? 'ยกเว้น' : '×' + t.rent_mul} />
      {c.entity === 'company' && <Row k="หัก ณ ที่จ่าย" v="5% ของฐานก่อน VAT" gold />}
      <Sec>ประวัติการเช่า ({hist.length} ครั้ง · รวม {B(totalOf(c.id))} ฿)</Sec>
      {hist.map(ct => (
        <div className="dw-item" key={ct.id}>
          <div>
            <div className="n">{ct.contract_no} · {ct.status === 'open' ? 'กำลังเช่า' : ct.status === 'closed' ? 'ปิดแล้ว' : 'ยกเลิก'}</div>
            <div className="s">{thDateTime(ct.created_at)} · {Number(ct.net_rent) ? B(ct.net_rent) + ' ฿' : 'ยกเว้นค่าเช่า'}</div>
          </div>
        </div>
      ))}
      {!hist.length && <div className="empty" style={{ padding: '10px 0' }}>ยังไม่เคยเช่า</div>}
      <div className="dw-act">
        <button onClick={() => { closeDrawer(); go('new'); }}>เปิดสัญญาเช่าใหม่ให้ลูกค้ารายนี้ <span className="ar">→</span></button>
      </div>
    </>));
  };

  return (<>
    <h2>ทะเบียนลูกค้าและประวัติการเช่า</h2>
    <div className="hint">กดที่แถวเพื่อดูข้อมูลติดต่อและประวัติทั้งหมด</div>
    <div style={{ margin: '14px 0 18px' }}>
      <input value={q} onChange={e => setQ(e.target.value)}
        placeholder="ค้นหา ชื่อ / บริษัท / เบอร์ / อีเมล / LINE"
        style={{ width: '100%', maxWidth: 420, border: 0, borderBottom: '1px solid var(--line2)', background: 'transparent', padding: '9px 2px', fontFamily: 'var(--sans)', fontSize: 15 }} />
    </div>
    <div className="card">
      <table>
        <thead><tr>
          <th>ลูกค้า</th><th>ประเภท</th><th>ระดับ</th><th>ติดต่อ</th><th className="r">ครั้งที่เช่า</th><th className="r">ยอดสะสม</th>
        </tr></thead>
        <tbody>
          {list.map(c => (
            <tr key={c.id} className="clickrow" onClick={() => openCust(c)}>
              <td>
                <div style={{ fontWeight: 600 }}>{custName(c) || '—'}</div>
                <div className="mono" style={{ fontSize: 11, color: 'var(--muted)' }}>
                  {c.entity === 'company' ? 'เลขภาษี ' + (c.tax_id || '—') : (c.phone || '')}
                </div>
              </td>
              <td>{c.entity === 'company' ? <span className="chip c-out">นิติบุคคล</span> : <span className="chip c-free">บุคคลธรรมดา</span>}</td>
              <td>{tierOf(c.tier).name}</td>
              <td className="mono" style={{ fontSize: 12 }}>{c.phone || '—'}<br /><span style={{ color: 'var(--muted)' }}>{c.line_id || '—'}</span></td>
              <td className="r mono">{historyOf(c.id).length}</td>
              <td className="r mono" style={{ fontWeight: 600 }}>{B(totalOf(c.id))}</td>
            </tr>
          ))}
          {!list.length && <tr><td colSpan={6} className="empty">ไม่พบลูกค้า</td></tr>}
        </tbody>
      </table>
    </div>
  </>);
}
